import { createRouter, createWebHistory } from 'vue-router'
import Home     from '../views/Home.vue'
import NextWeek from "../views/NextWeek";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
	{
		path: '/next',
		name: 'Nächste Woche',
		component: NextWeek
	},
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: () => import('../views/Impressum')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
